module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-down--i.0aa52264.svg";